export const enNotificationsTranslations = {
	notifications: {
		'auth/login/fulfilled': 'Successfully logged in',
		'auth/register/fulfilled': 'Account created successfully',
		'organization/createUserOrganization/fulfilled': 'Organization created successfully',
		'organization/updateUserOrganization/fulfilled': 'Organization updated successfully',
		'branch/createNewBranch/fulfilled': 'Branch created successfully',
		'branch/updateBranchData/fulfilled': 'Branch updated successfully',
		'branch/deleteBranchData/fulfilled': 'Branch deleted successfully',
		'category/createNewCategory/fulfilled': 'Category created successfully',
		'category/updateCategoryData/fulfilled': 'Category updated successfully',
		'category/deleteCategoryData/fulfilled': 'Category deleted successfully',
		'menuItem/createNewMenuItem/fulfilled': 'Menu item created successfully',
		'menuItem/updateMenuItemData/fulfilled': 'Menu item updated successfully',
		'menuItem/deleteMenuItemData/fulfilled': 'Menu item deleted successfully',
		'branch/publishBranch/fulfilled': 'Menu published successfully',
		unexpectedError: 'An unexpected error occurred'
	}
};